import React from 'react';
import { NumericFormatProps } from 'react-number-format';

import {
  CurrencyNumberFormat,
  CurrencyNumberFormatProps,
} from '@app/common/utils/currencyNumberFormat/currencyNumberFormat';

/**
 * Max value according our validation rules
 * https://cf.mfmnow.com/display/SPEC/Data+Validation+Rules#DataValidationRules-DollarAmount
 */
export const MAX_VALUE = 9999999.99;

export type AmountFieldProps = CurrencyNumberFormatProps;
export type AmountFieldRef = NumericFormatProps;

export const AmountField = React.forwardRef((
  props: AmountFieldProps,
  ref: React.Ref<AmountFieldRef>,
) => (
  <CurrencyNumberFormat
    autoComplete="off"
    data-stable-name="AmountInput"
    ref={ref}
    {...props}
  />
));
